import { useMemo } from "react";
import { useAvailableMerchants } from "./useAvailableMerchants";
import { usePortalContext } from "./usePortalContext";

export function useMerchant() {
  const { availableMerchants } = useAvailableMerchants();
  const { context } = usePortalContext();

  const merchant = useMemo(() => {
    if (context?.type !== "merchant") return undefined;
    return availableMerchants.find((merchant) => merchant.id === context.id);
  }, [availableMerchants, context]);

  return { merchant };
}
